<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-also-by element-with-heading" id="also-by-bk-duncan">
<div class="heading heading-with-title heading-without-image" id="also-by-bk-duncan-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by BK Duncan</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-bk-duncan-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="first-phrase"><span class="drop-cap">T</span>he stunning second</span> instalment in the May Keaps <span class="last-word">series</span>:</p>
<p class="subsq also-by-content"><i>Found Drowned</i><i> </i>( May Keaps Book <span class="last-word">2</span>)</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><span class="first-phrase"><span class="drop-cap">B</span>K Duncan</span> also writes as Ruth Wade and you will also enjoy her unmissable historical thriller, <i>Walls of <span class="last-word">Silence</span></i>.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-bk-duncan.vue?61e4fcc0